const initialValues = (country, state, phone) => ({
    Country: country,
    State: state,
    Phone: phone,
});
export default initialValues;
